// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1yOXM","upload":"Small_upload__gfP_6","imageWrap":"Small_imageWrap__WkXrO","removeBtn":"Small_removeBtn__Xr8Th"};